function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pathOr from 'ramda/src/pathOr';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { CurrentBusinessUnitCurrencyCodeSelector, IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { fetchAdjustmentReasons, fetchCodeTypes, fetchCreditReasons } from 'invision-core/src/components/metadata/codes/codes.actions';
import { IsOfferFeatureEnabled, MetadataOptionsForCodeValuesSelector, MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { IsARMInMaintenanceModeSelector } from 'invision-core/src/components/warnings/warnings.selectors';
import { getFilterService } from 'invision-core/src/components/injectables/injector.helper';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import CustomerCareKeys from '../../../../../locales/keys';
import { fetchInvoices, fetchDeposits } from '../../../../../reducers/actions/customer.cases.actions';
import { retrieveChangeOfferEligibilityRules } from '../../../../../reducers/actions/customer.offering.actions';
import { CustomerDespositsSelector, CustomerInvoicesSelector, IsFetchingInvoicesSelector } from '../../../../../reducers/selectors/customer.cases.selectors';
import { AutopayConfigurationAdditionalPropertiesSelector, IsAutoPayEnabledSelector } from '../../../../../reducers/selectors/autopay.configuration.selectors';
import { CurrentCustomerCurrencyCodeSelector, CurrentCustomerIsExternallyManagedARSelector, CurrentCustomerIdSelector, CurrentCustomerNameSelector, CurrentCustomerSelector, IsPIIDataAccessEnabledSelector } from '../../../../../reducers/selectors/customer.selectors';
import { IsChangeOfferEligibilityRulesLoaded } from '../../../../../reducers/selectors/customer.offerings.selectors';
import { ConvergentBillerIsInPromiseToPay, ConvergentBillerSubscriberRemainingWriteOffAmountSelector, ConvergentBillerSubscriberSummarySelector, CreditLimitBreachedSelector, CreditLimitSummarySelector, CurrentAccountSummarySelector, IsCurrentAccountPostpaidSelector, IsFetchingDepositsSelector, IsFetchingSubscriberSummarySelector, MostRecentInvoiceSelector } from '../../../../../reducers/selectors/customer.convergent.biller.selectors';
import { IsFetchingOrdersSelector } from './../../../../../reducers/selectors/order.history.selectors';
import { retrieveConvergentBillerSubscriberSummary, retrieveConvergentBillerTreatmentDetails } from '../../../../../reducers/actions/customer.convergent.biller.actions';
import { retrieveAndOpenConvergentBillerLedgerInvoice } from './../../../../../reducers/actions/customer.billing.actions';
import { searchOrders } from './../../../../../reducers/actions/order.history.actions';
import { createTableDepositsHeaders } from './../../../cases/list/list.selectors.helper';
import { CASE_CATEGORIES } from './../../../cases/list/case.constants';
import { CASES_DETAILS_STATE_REDIRECT } from '../../../cases/cases.config';
import MakePaymentConstants from './../../../makePayment/make.payment.constants';
import { IsFetchingInvoiceContentSelector } from '../../../../../reducers/selectors/customer.billing.selectors';
import { OfferEligibilityIdsSelector } from '../../../../../reducers/selectors/dashboard.selectors';
import { PaymentInstrumentsWithTypeNamesViewModel } from '../../../../../reducers/selectors/customer.ewallet.selectors';
import { retrieveAvailablePaymentInstrumentTypes } from '../../../../../reducers/actions/customer.ewallet.actions';
import { fetchCustomerInventory } from '../../../../../reducers/actions/customer.inventory.actions';
import { CanApplyCreditSelector } from '../../../../../reducers/selectors/apply.credit.modal.selectors';
import { ONE_TIME_MAKE_PAYMENT, DISPUTE_INVOICE } from '../../../../../security.attributes';
var AccountBalanceController = /*#__PURE__*/function () {
  function AccountBalanceController($ngRedux, $state, $timeout, uiNotificationService) {
    _classCallCheck(this, AccountBalanceController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      closeCreditRefundModal: this.closeCreditRefundModal.bind(this),
      hasMakePaymentAccess: this.hasMakePaymentAccess.bind(this),
      hasLatePayment: this.hasLatePayment.bind(this),
      onMoreActionsItemSelection: this.onMoreActionsItemSelection.bind(this),
      onSuccessfulCreditSubmission: this.onSuccessfulCreditSubmission.bind(this),
      uiNotificationService: uiNotificationService,
      zeroValueAmount: 0
    });
  }
  return _createClass(AccountBalanceController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this,
        _this$state$mostRecen2;
      var controllerActions = {
        fetchAdjustmentReasons: fetchAdjustmentReasons,
        fetchCodeType: fetchCodeTypes,
        fetchDeposits: fetchDeposits,
        fetchCreditReasons: fetchCreditReasons,
        fetchCustomerInventory: fetchCustomerInventory,
        fetchInvoices: fetchInvoices,
        retrieveAndOpenConvergentBillerLedgerInvoice: retrieveAndOpenConvergentBillerLedgerInvoice,
        retrieveChangeOfferEligibilityRules: retrieveChangeOfferEligibilityRules,
        retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
        retrieveConvergentBillerSubscriberSummary: retrieveConvergentBillerSubscriberSummary,
        retrieveConvergentBillerTreatmentDetails: retrieveConvergentBillerTreatmentDetails,
        searchOrders: searchOrders
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        var accountSummary = CurrentAccountSummarySelector(store);
        var remainingWriteOffAmount = ConvergentBillerSubscriberRemainingWriteOffAmountSelector(store);
        var mostRecentInvoice = MostRecentInvoiceSelector(store);
        var userSecurityAttributes = UserSecurityAttributesSelector(store);
        var isAutoPayConfigured = accountSummary && accountSummary.AutoPayConfigured;
        var hasAutoPayFailed = accountSummary && accountSummary.HasAutoPayFailed;
        var moreMenuItems = _this.getMoreMenuItems(mostRecentInvoice, accountSummary, userSecurityAttributes);
        return {
          adjustmentReasonsLoaded: MetadataCodeLoadedSelector(CODES.BalanceAdjustmentReason, store),
          adjustmentReasonOptions: MetadataOptionsForCodeValuesSelector(CODES.BalanceAdjustmentReason, store),
          accountSummary: accountSummary,
          autopayConfigurationsLoaded: MetadataCodeLoadedSelector(CODES.AutopayConfig, store),
          autopayConfigurations: AutopayConfigurationAdditionalPropertiesSelector(store),
          canApplyCredit: CanApplyCreditSelector(store),
          creditReasonsLoaded: MetadataCodeLoadedSelector(CODES.CreditReasons, store),
          currentBusinessUnitCurrencyCode: CurrentBusinessUnitCurrencyCodeSelector(store),
          currentCustomerCurrencyCode: CurrentCustomerCurrencyCodeSelector(store),
          currentCustomerDeposits: CustomerDespositsSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentCustomerName: CurrentCustomerNameSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerIsExternallyManagedAR: CurrentCustomerIsExternallyManagedARSelector(store),
          ewalletPaymentInstruments: PaymentInstrumentsWithTypeNamesViewModel(store),
          creditLimitSummary: CreditLimitSummarySelector(store),
          featureConfigurationsLoaded: MetadataCodeLoadedSelector(CODES.FeatureConfiguration, store),
          hasAutoPayFailed: hasAutoPayFailed,
          hasPromiseToPay: ConvergentBillerIsInPromiseToPay(store),
          isAutoPayConfigured: isAutoPayConfigured,
          isAutoPayEnabled: IsAutoPayEnabledSelector(store),
          isARMInMaintenanceModeEnabled: IsARMInMaintenanceModeSelector(store),
          isChangeOfferEligibilityRulesLoaded: IsChangeOfferEligibilityRulesLoaded(store),
          isDbss: IsDbss(store),
          isCreditLimitBreached: CreditLimitBreachedSelector(store),
          isCurrentAccountPostpaid: IsCurrentAccountPostpaidSelector(store),
          isFetchingInvoices: IsFetchingInvoicesSelector(store),
          isFetchingDeposits: IsFetchingDepositsSelector(store),
          isFetchingInvoiceContent: IsFetchingInvoiceContentSelector(store),
          isFetchingOrders: IsFetchingOrdersSelector(store),
          isFetchingAccountSummary: IsFetchingSubscriberSummarySelector(store),
          isItvOffersEnabled: IsOfferFeatureEnabled(store),
          isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store),
          invoices: CustomerInvoicesSelector(store),
          moreMenuItems: moreMenuItems,
          mostRecentInvoice: mostRecentInvoice,
          offerEligibilityIds: OfferEligibilityIdsSelector(store),
          periodTypesLoaded: MetadataCodeLoadedSelector(CODES.PeriodType, store),
          reasonOptions: MetadataOptionsForCodeValuesSelector(CODES.CreditReasons, store),
          remainingWriteOffAmount: remainingWriteOffAmount,
          subscriberSummary: ConvergentBillerSubscriberSummarySelector(store),
          userSecurityAttributes: userSecurityAttributes
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      if ((!this.state.invoices || !this.state.invoices.length) && this.state.currentCustomer.ConvergentBillerId && !this.state.isFetchingInvoices) {
        this.actions.fetchInvoices(this.state.currentCustomerId);
      }
      if (this.state.currentCustomer.ConvergentBillerId) {
        if (this.state.hasPromiseToPay) {
          this.actions.retrieveConvergentBillerTreatmentDetails(this.state.currentCustomerId);
        }
        if (!this.state.isChangeOfferEligibilityRulesLoaded && this.state.offerEligibilityIds && this.state.offerEligibilityIds.length) {
          this.actions.retrieveChangeOfferEligibilityRules(this.state.currentCustomerId, this.state.offerEligibilityIds);
        }
      }
      if (!this.state.autopayConfigurationsLoaded) {
        this.actions.fetchCodeType(CODES.AutopayConfig);
      }
      if (!this.state.creditReasonsLoaded) {
        this.actions.fetchCreditReasons();
      }
      if (!this.state.adjustmentReasonsLoaded) {
        this.actions.fetchAdjustmentReasons();
      }
      if (!this.state.periodTypesLoaded) {
        this.actions.fetchCodeType(CODES.PeriodType);
      }
      this.customerCareKeys = CustomerCareKeys;
      this.DASHBOARD = MakePaymentConstants.MAKE_PAYMENT_TYPES.DASHBOARD;
      this.CASE_CATEGORIES = CASE_CATEGORIES;
      this.gridVisible = false;
      this.grid = this.gridSetup();
      this.depositsModalConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this.depositsModalConfigApi = event.api;
        }
      };
      this.applyCreditRefundModalConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.applyCreditRefundModalApi = api;
        }
      };
      this.actions.retrieveAvailablePaymentInstrumentTypes({
        Currency: this.state.currentCustomerCurrencyCode || this.state.currentBusinessUnitCurrencyCode
      }).catch(function (error) {
        _this.uiNotificationService.transientError(error.translatedMessage);
      });
      this.caseModalProps = {
        isOpen: false,
        onClose: function onClose() {
          _this.caseModalProps.isOpen = false;
        },
        onSubmit: function onSubmit(caseDetails) {
          _this.caseModalProps.isOpen = false;
          _this.uiNotificationService.success(i18n.translate(CustomerCareKeys.CASE.CREATED_SUCCESSFULLY));
          _this.$state.go(CASES_DETAILS_STATE_REDIRECT, {
            customerId: _this.state.currentCustomerId,
            caseId: caseDetails.Id.Value
          });
        },
        openCaseModal: function openCaseModal() {
          var _this$state$mostRecen;
          _this.caseModalProps.disputeDetails.selectedInvoiceNumber = (_this$state$mostRecen = _this.state.mostRecentInvoice) === null || _this$state$mostRecen === void 0 ? void 0 : _this$state$mostRecen.InvoiceNumber;
          _this.caseModalProps.isOpen = true;
        },
        disputeDetails: {
          selectedInvoiceNumber: (_this$state$mostRecen2 = this.state.mostRecentInvoice) === null || _this$state$mostRecen2 === void 0 ? void 0 : _this$state$mostRecen2.InvoiceNumber
        },
        caseTemplateId: CASE_CATEGORIES.INVOICE_DISPUTE,
        routeParams: {
          customerId: this.state.currentCustomerId
        }
      };
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "hasLatePayment",
    value: function hasLatePayment() {
      var _this$state, _this$state$accountSu;
      return (_this$state = this.state) !== null && _this$state !== void 0 && (_this$state$accountSu = _this$state.accountSummary) !== null && _this$state$accountSu !== void 0 && _this$state$accountSu.PostpaidDetails ? this.state.accountSummary.PostpaidDetails.LatePaymentEligible && this.state.accountSummary.PostpaidDetails.LatePaymentAmountDue > 0 && this.state.accountSummary.PostpaidDetails.DueDate !== null && this.state.accountSummary.PostpaidDetails.LatePaymentFeeAmount > 0 : false;
    }
  }, {
    key: "gridSetup",
    value: function gridSetup() {
      var _this2 = this;
      return {
        data: [],
        appScopeProvider: this,
        onRegisterApi: function onRegisterApi(event) {
          _this2.gridApi = event.grid.api;
        },
        columnDefs: createTableDepositsHeaders()
      };
    }
  }, {
    key: "hasLastPayment",
    value: function hasLastPayment() {
      return pathOr(false, ['accountSummary', 'PostpaidDetails', 'LastPaymentDate'], this.state);
    }
  }, {
    key: "viewDeposits",
    value: function viewDeposits() {
      var _this3 = this;
      this.depositsModalConfigApi.open();
      this.actions.searchOrders(this.state.currentCustomerId).then(function () {
        return _this3.actions.fetchDeposits(_this3.state.currentCustomerId);
      }).then(function () {
        _this3.grid.data = _this3.state.currentCustomerDeposits;
        _this3.gridVisible = true;
      });
    }
  }, {
    key: "onCloseDepositsPopup",
    value: function onCloseDepositsPopup() {
      this.gridVisible = false;
      this.depositsModalConfigApi.close();
    }
  }, {
    key: "retrieveInvoiceContent",
    value: function retrieveInvoiceContent() {
      if (this.state.mostRecentInvoice) {
        var data = {
          customerId: this.state.currentCustomerId,
          customerName: this.state.currentCustomerName,
          invoiceNumber: this.state.mostRecentInvoice.InvoiceNumber,
          request: {
            InvoiceId: this.state.mostRecentInvoice.InvoiceId,
            InvoiceNumber: this.state.mostRecentInvoice.InvoiceNumber,
            IssueDate: this.state.mostRecentInvoice.IssueDate
          }
        };
        this.actions.retrieveAndOpenConvergentBillerLedgerInvoice(data);
      }
    }
  }, {
    key: "goToAutoPay",
    value: function goToAutoPay() {
      this.$state.go('index.customercare.customer.autoPay', {
        accountNumber: this.$state.params.accountNumber
      });
    }
  }, {
    key: "goToAutoPayPostpaid",
    value: function goToAutoPayPostpaid() {
      this.$state.go('index.customercare.customer.configureAutopay', {
        accountNumber: this.$state.params.accountNumber
      });
    }
  }, {
    key: "showAutoPayLabel",
    value: function showAutoPayLabel() {
      return this.state.isAutoPayEnabled && (this.state.isAutoPayConfigured || this.state.accountSummary) && this.state.isCurrentAccountPostpaid;
    }
  }, {
    key: "autoPayConfiguredLabel",
    value: function autoPayConfiguredLabel() {
      var $filter = getFilterService();
      var substitutions = {};
      if (this.state.accountSummary.PostpaidDetails) {
        substitutions = {
          amount: this.state.accountSummary.PostpaidDetails.DueDate ? $filter('invCurrency')(this.state.accountSummary.PostpaidDetails.Total, this.state.accountSummary.currencyCode) : i18n.translate(CustomerCareKeys.NOT_APPLICABLE),
          date: $filter('localShortDate')(this.state.accountSummary.NextAutoPayDate)
        };
      }
      var suspended = this.state.accountSummary && this.state.accountSummary.AutoPaySuspended;
      var suspendedMessage = this.state.accountSummary.AutoPaySuspensionEndDate ? i18n.translate(CustomerCareKeys.AUTO_PAY.SUSPENDED_UNTIL, {
        date: $filter('localShortDate')(this.state.accountSummary.AutoPaySuspensionEndDate)
      }) : i18n.translate(CustomerCareKeys.AUTO_PAY.SUSPENDED);
      return suspended ? suspendedMessage : i18n.translate(CustomerCareKeys.AUTO_PAY.AUTO_PAY_ENABLE, substitutions);
    }
  }, {
    key: "latePaymentLabel",
    value: function latePaymentLabel() {
      var $filter = getFilterService();
      var latePayment = {
        dueAmount: $filter('invCurrency')(this.state.accountSummary.PostpaidDetails.LatePaymentAmountDue, this.state.accountSummary.PostpaidDetails.CurrencyCode),
        date: $filter('localShortDate')(this.state.accountSummary.PostpaidDetails.DueDate),
        latePaymentFee: $filter('invCurrency')(this.state.accountSummary.PostpaidDetails.LatePaymentFeeAmount, this.state.accountSummary.PostpaidDetails.CurrencyCode)
      };
      return i18n.translate(CustomerCareKeys.CUSTOMER_DASHBOARD.LATE_PAYMENT_FEE.LATE_PAYMENT_FEE_LABEL, latePayment);
    }
  }, {
    key: "onMoreActionsItemSelection",
    value: function onMoreActionsItemSelection(option) {
      switch (option.item.id) {
        case CustomerCareKeys.DISPUTE_INVOICE:
          this.caseModalProps.openCaseModal();
          break;
        case CustomerCareKeys.VIEW_DEPOSITS:
          this.viewDeposits();
          break;
        case CustomerCareKeys.TRANSACTION_DETAILS.APPLY_CREDIT:
          this.openCreditRefundModal();
          break;
        default:
          break;
      }
    }
  }, {
    key: "getMoreMenuItems",
    value: function getMoreMenuItems(mostRecentInvoice, accountSummary, userSecurityAttributes) {
      var moreMenuItems = [];
      var hasDeposits = pathOr(0, ['PostpaidDetails', 'TotalDepositAmount'], accountSummary) > 0;
      if (hasAccess(userSecurityAttributes, DISPUTE_INVOICE) && mostRecentInvoice) {
        moreMenuItems.push({
          id: CustomerCareKeys.DISPUTE_INVOICE,
          title: i18n.translate(CustomerCareKeys.DISPUTE_INVOICE)
        });
      }
      if (hasDeposits) {
        moreMenuItems.push({
          id: CustomerCareKeys.VIEW_DEPOSITS,
          title: i18n.translate(CustomerCareKeys.VIEW_DEPOSITS)
        });
      }
      if (this.state && this.state.isDbss && this.state.canApplyCredit) {
        moreMenuItems.push({
          id: CustomerCareKeys.TRANSACTION_DETAILS.APPLY_CREDIT,
          title: i18n.translate(CustomerCareKeys.TRANSACTION_DETAILS.APPLY_CREDIT)
        });
      }
      return moreMenuItems;
    }
  }, {
    key: "openCreditRefundModal",
    value: function openCreditRefundModal() {
      this.showCreditRefundModal = true;
      this.additionalApiData = {
        AccountNumber: this.state.accountSummary.AccountNumber
      };
      this.$timeout(this.applyCreditRefundModalApi.open);
    }
  }, {
    key: "closeCreditRefundModal",
    value: function closeCreditRefundModal() {
      this.showCreditRefundModal = false;
      this.applyCreditRefundModalApi.close();
    }
  }, {
    key: "onSuccessfulCreditSubmission",
    value: function onSuccessfulCreditSubmission() {
      this.uiNotificationService.transientSuccess(i18n.translate(CustomerCareKeys.TRANSACTION_DETAILS.SUCCESSFUL_REFUND));
      this.closeCreditRefundModal();
      this.actions.retrieveConvergentBillerSubscriberSummary(this.state.currentCustomerId, true);
    }
  }, {
    key: "hasMakePaymentAccess",
    value: function hasMakePaymentAccess() {
      return (this.state.isCurrentAccountPostpaid || this.isARCSubscriptionMgmtFeatureToggle) && !this.state.currentCustomerIsExternallyManagedAR && hasAccess(this.state.userSecurityAttributes, ONE_TIME_MAKE_PAYMENT);
    }
  }]);
}();
export default {
  template: require('./account.balance.html'),
  controller: AccountBalanceController,
  bindings: {
    isArcSubscriptionFeatureToggle: '<'
  },
  controllerAs: 'AccountBalance'
};